import { noop } from 'lodash'

import { getGA4SessionId, getGAClientId } from 'lib/gtm'
import {
  apiService,
  createRequestHeadersConfig,
  getQueryClient,
  QueryKey
} from 'shared/api'
import { getWebSourceFromNavigator } from 'shared/ui/utils/layout'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'

import { BlikErrorType, PaymentMethodsNames } from '../payment/types'

import { PurchaseResponse, SaleOrderPayload } from './types'

const api = apiService()

interface PlaceSaleOrderParams {
  cartId: string
  token?: string
  paymentMethodId: string
  blikCode?: string
  cancelLoading?: () => void
}

export const placeSaleOrder = async ({
  cartId,
  token,
  paymentMethodId,
  blikCode,
  cancelLoading
}: PlaceSaleOrderParams): Promise<PurchaseResponse | null> => {
  try {
    const payload: SaleOrderPayload = {
      paymentMethodId,
      blik_code: blikCode || undefined,
      session_id: getGA4SessionId(),
      client_id: getGAClientId(),
      source:
        typeof window !== 'undefined' ? getWebSourceFromNavigator() : 'web'
    }

    const result = (await api.post(`/cart/${cartId}/order`, payload, {
      ...createRequestHeadersConfig(token, { noretry: 'true' })
    })) as PurchaseResponse

    void getQueryClient()
      .invalidateQueries({
        queryKey: [QueryKey.profileOrders]
      })
      .catch(noop)

    if (result) {
      return result
    } else {
      return null
    }
  } catch (err) {
    const error = err as BlikErrorType

    void getQueryClient()
      .invalidateQueries({
        queryKey: [QueryKey.profileOrders]
      })
      .catch(noop)

    if (error.response?.data?.paymentMethodName === PaymentMethodsNames.Blik) {
      // Callers catch the BLIK error payload itself (paymentMethodName, …), not an Error.
      throw error?.response?.data as unknown as Error
    }
    toast.error(getApiErrors(err))
    cancelLoading && cancelLoading()

    return null
  }
}
